import { Button } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type SmsTemplateListEmptyStateProps = {
  variant: 'global' | 'filtered';
  onCreate?: () => void;
};

export const SmsTemplateListEmptyState: FC<SmsTemplateListEmptyStateProps> = ({ variant, onCreate }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-secondary-border bg-white py-16'>
      <h3 className='text-lg font-semibold text-slate-900'>
        {variant === 'global' ? t('smsWorkspace.templates.noTemplatesFound') : t('smsWorkspace.templates.noFilteredTemplatesFound')}
      </h3>
      {variant === 'global' ? (
        <p className='text-secondary-600 max-w-md text-center text-sm'>{t('smsWorkspace.templates.noTemplatesFoundDescription')}</p>
      ) : null}
      {variant === 'global' && onCreate ? <Button onClick={onCreate} text={t('smsWorkspace.templates.createButton')} /> : null}
    </div>
  );
};
